module.exports = __webpack_public_path__ + "static/img/userInfoBg.0b470337.png";